import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GoogleMapsService {
  // Usa el formato público sin API key, igual que los iframes generados por Google Maps al compartir
  generateMapIframe(encodedAddress: string): string {
    return `<iframe
      width="100%"
      height="300"
      frameborder="0"
      style="border:0"
      src="https://maps.google.com/maps?q=${encodedAddress}&output=embed&hl=es"
      allowfullscreen
      loading="lazy"
      referrerpolicy="no-referrer-when-downgrade">
    </iframe>`;
  }

  generateMapUrl(address: string): string {
    return `https://maps.google.com/maps?q=${encodeURIComponent(address)}&output=embed&hl=es`;
  }
}
